import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { Box, Typography, useTheme } from '@mui/material';

interface WelcomeViewButtonProps {
  text: string;
  action: () => void;
}

const WelcomeViewButton = (props: WelcomeViewButtonProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        cursor: 'pointer',
        width: '50%',
        padding: {
          xs: '.25em',
          md: '.5em',
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1em',
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
          color: 'white',
        },
      }}
      onClick={props.action}
    >
      <Typography fontWeight={500} fontSize="1.3em">
        {props.text}
      </Typography>
      <ArrowForwardIosRoundedIcon sx={{ fontSize: '2em' }} />
    </Box>
  );
};

export default WelcomeViewButton;
